var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.data.GradedCommissionList),function(item,index){return _c('div',{key:index},[_vm._v("\n      "+_vm._s(item.CommissionText)+"\n      "),_c('span',{staticClass:"cs-gradedCommission-range"},[_vm._v(_vm._s(_vm.getRangeDesc(item)))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-622e8e5e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/paginationCells/gradedCommissionCell.vue
// module id = B4Ns
// module chunks = 0